export default class BaseModel {
  attributes = {}

  get(key){
    return this.attributes[key]
  }
}
